import * as React from "react";
function SvgInstagram(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M16 5c3 0 3.36 0 4.54.07a8.05 8.05 0 012.66.51 5.27 5.27 0 011.95 1.27 5.27 5.27 0 011.27 2 8.05 8.05 0 01.51 2.66C27 12.64 27 13 27 16s0 3.36-.07 4.54a8.05 8.05 0 01-.51 2.66 5.61 5.61 0 01-3.22 3.22 8.05 8.05 0 01-2.66.51C19.36 27 19 27 16 27s-3.36 0-4.54-.07a8.05 8.05 0 01-2.66-.51 5.27 5.27 0 01-2-1.27 5.27 5.27 0 01-1.22-1.95 8.05 8.05 0 01-.51-2.66C5 19.36 5 19 5 16s0-3.36.07-4.54a8.05 8.05 0 01.51-2.66 5.27 5.27 0 011.27-2 5.27 5.27 0 012-1.27 8.05 8.05 0 012.66-.51C12.64 5 13 5 16 5zm0 2c-2.94 0-3.29 0-4.45.06a6.31 6.31 0 00-2.06.38 3.46 3.46 0 00-1.27.83 3.32 3.32 0 00-.82 1.26 5.84 5.84 0 00-.38 2.07C7 12.71 7 13.05 7 16s0 3.29.06 4.45a5.79 5.79 0 00.38 2.06 3.59 3.59 0 002.09 2.09 5.83 5.83 0 002.06.38c1.15.02 1.5.02 4.41.02s3.28 0 4.45-.06a5.83 5.83 0 002.06-.38 3.63 3.63 0 002.06-2.06 6.06 6.06 0 00.43-2.03V16c0-3 0-3.29-.06-4.45a6.06 6.06 0 00-.38-2.06 3.59 3.59 0 00-2.09-2.09 6.31 6.31 0 00-2.02-.4H16zm0 3.37A5.65 5.65 0 1110.35 16 5.65 5.65 0 0116 10.35zm0 9.31A3.66 3.66 0 1012.34 16 3.66 3.66 0 0016 19.66zm5.87-8.21a1.32 1.32 0 111.32-1.32 1.32 1.32 0 01-1.32 1.3z"
        fill="#fff"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgInstagram);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
